import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { FileUpload } from "primeng/fileupload";

@Component({
  selector: 'operative-upload-form',
  templateUrl: './operative-upload-form.component.html',
  styleUrls: ['./operative-upload-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OperativeUploadFormComponent implements OnInit {
  acceptedFileTypes = '.doc, .docx,.png, .jpg, .jpeg, .txt,.ppt, .pptx,.xls, .xlsx, .xlsm, .pdf';
  @ViewChild('documentUploadForm', { static: true }) documentUploadForm: NgForm;
  @ViewChild('uploader', { static: true }) uploader: FileUpload;
  @Input() isEditing = true;
  @Input() isViewOnly = false;
  @Input() saveAttempted: boolean = true;
  @Input() submitted: boolean = false;
  @Input() maxFileSize = 20971520; // TODO Get max file size from settings.. default to 20mb
  defaultFileName;
  // @Output() documentUploadFormChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() documentTypes: IDocumentType[];
  @Input() documentSummary: IEntityDocumentSummary;
  @Output() formStatusChange: EventEmitter<any> = new EventEmitter<File>();
  @Output() canSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() fileUpload: EventEmitter<File> = new EventEmitter<File>();
  @Output() fileRemove: EventEmitter<boolean> = new EventEmitter<boolean>();

  file: File;
  //errorMessage: string;
  //showErrorMessage = false;
  @Output() documentUploadRequest: EventEmitter<any> = new EventEmitter<any>();
  otherDocumentType: any;
  selectedDocumentTypeId: any;
  addingNewDocumentType: boolean;
  newDocumentType: any;
  saveNewDocumentTypeAttempted: any;
  tempFileName: string = '';
  creationMaxDate: Date = new Date(Date.now());
  selectedMaxDate: Date = new Date(Date.now());
  selectedMinDate: Date;
  filetypeTooltip: string;



  constructor() {
  }

  ngOnInit(): void {
    if (this.documentSummary?.originalFilename !== '') {
      this.defaultFileName = this.documentSummary.originalFilename;
    }

    if (this.documentSummary.documentTypeId === '') {
      const defaultDocumentType = this.documentTypes.find(c => c.isDefault);
      if (defaultDocumentType) {
        this.documentSummary.documentTypeId = defaultDocumentType.id;
      }
    }
  }

  ngOnDestroy() {
  }

  onFileRemove(file?: File) {
    const index = this.uploader.files.indexOf(file);
    if (index > -1) {
      this.uploader.remove(null, index);
    }
    this.defaultFileName = this.tempFileName;
    this.documentSummary.originalFilename = this.tempFileName;
    this.fileRemove.emit(true);
    // this.formStatusChange.emit(false);
  }

  onFileAdd(event: any) {
    if (event?.files?.length > 0) {
      const file = event?.files[0];
      this.defaultFileName = file.name;
      this.fileUpload.emit(file);
      this.formStatusChange.emit(this.documentUploadForm.form.valid);
    }
  }
}
